import { Matrix } from 'ml-matrix';
import { fcnnls } from './fcnnls';
export function fcnnlsVector(X, y, options = {}) {
    if (!Array.isArray(y)) {
        throw new TypeError('y must be a 1D Array');
    }
    const Y = Matrix.columnVector(y);
    return fcnnls(X, Y, options);
}
//# sourceMappingURL=fcnnlsVector.js.map